


const title = "Art Categories";

const cscContentList = [
    {
        link: '#',
        left: 'Drawing & Sketching',
        right: '42',
    },
    {
        link: '#',
        left: 'Painting (Acrylic, Oil, Watercolor)',
        right: '37',
    },
    {
        link: '#',
        left: 'Digital Art & Illustration',
        right: '29',
    },
    {
        link: '#',
        left: 'Graphic Design',
        right: '56',
    },
    {
        link: '#',
        left: 'Photography',
        right: '20',
    },
    {
        link: '#',
        left: 'Animation & Motion Graphics',
        right: '18',
    },
    {
        link: '#',
        left: 'Sculpting & Clay Modeling',
        right: '14',
    },
    {
        link: '#',
        left: 'Calligraphy & Hand Lettering',
        right: '22',
    },
    {
        link: '#',
        left: 'Art History',
        right: '11',
    },
    {
        link: '#',
        left: 'Crafts & DIY Projects',
        right: '33',
    },
    {
        link: '#',
        left: 'Fashion Design',
        right: '25',
    },
    {
        link: '#',
        left: 'Music & Performing Arts',
        right: '30',
    },
];



const CourseSideCetagory = () => {
    return (
        <div className="course-side-cetagory">
            <div className="csc-title">
                <h5 className="mb-0">{title}</h5>
            </div>
            <div className="csc-content">
                <div className="csdc-lists">
                    <ul className="lab-ul">
                        {cscContentList.map((val, i) => (
                            <li key={i}>
                                <div className="csdc-left"><a href={val.link}>{val.left}</a></div>
                                <div className="csdc-right">{val.right}</div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
 
export default CourseSideCetagory;